import React, { useEffect, useRef } from "react";
import { useState } from "react";
import ReactTooltip from "react-tooltip";
import { Container, Row, Col, Button, } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Modal } from "react-bootstrap";

import {
  AcceptInvestorRequestAfterTxn,
  AcceptInvestorRequestPayment,
  getInvestorRequestPagination,
  RejectInvestorRequest,
  RejectInvestorRequestPayment,
  UpdatePaymentProof,
  UpdateStatusInvestorRequest
} from "../../stores/services/investor-request.service";
import moment from "moment";
import { BsCardChecklist } from "react-icons/bs";
import { BsListCheck } from "react-icons/bs";
import InvestorRequestTransaction from "../investor-request-transaction";
import { useSelector } from "react-redux";
import { searchTransactions } from "../../stores/services/transactions.service";
import { numberWithCommas } from "../../utils/customFunction";
import ViewInvesterRequest from "./ViewInvesterRequest";


const InvestedRequest = () => {

  const requestStatusArr = [
    {
      label: "All Requests",
      value: ""
    },
    {
      label: "Payment Pending",
      value: "PAYMENT-PENDING"
    },
    {
      label: "Payment Rejected",
      value: "PAYMENT-REJECTED"
    },
    {
      label: "Pending Approval",
      value: "PAYMENT-VERIFIED,SUBMITTED"
    },
    {
      label: "Accepted Requests",
      value: "ACCEPTED"
    },
    {
      label: "Rejected Requests",
      value: "REJECTED"
    },
  ]
  const requestTypeArr = [
    {
      label: "All",
      value: ""
    },
    {
      label: "Sale",
      value: "saleofunit",
    },
    {
      label: "Redemption",
      value: "redemptionofunits",
    },
    {
      label: "Conversion",
      value: "conversionofunits",
    },
  ]
  const [loading, setLoading] = useState<boolean>(false)
  const [refreshData, setRefreshData] = useState<boolean>(false)
  const [viewModalFlag, setViewModalFlag] = useState<boolean>(false)
  const [allInvestorRequestData, setAllInvestorRequestData] = useState<any>([])
  const [match, setMatch] = useState<any>()
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const [modalFlag, setModalFlag] = useState(false);
  const [rejectedAcceptedModalFlag, setRejectedAcceptModalFlag] = useState(false);
  const [txnModalFlag, setTxnModalFlag] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [onStartFlag, setOnStartFlag] = useState(false);
  const [pageNo, setPageNo] = useState(0);
  const [requestStatus, setRequestStatus] = useState("");
  const [comment, setComment] = useState("");
  const [txnIDKey, settxnIDKey] = useState("");
  const [relatedTxnIDKey, setRelatedTxnIDKey] = useState("");
  const [requestType, setRequestType] = useState("");
  const [keyForRejectAccept, setKeyForRejectAccept] = useState("");
  const [image, setImage] = useState("");
  const [folioNo, setFolioNo] = useState("");
  const [selectedItem, setSelectedItem] = useState<any>();
  const [redemptionAcceptKey, setRedemptionAcceptKey] = useState<boolean>(false);
  const [profilePicture, setProfilePicture] = useState<any>();
  const [fetchView, setFetchView] = useState<boolean>(false);
  const [loaderImageUploadRedemption, setLoaderImageUploadRedemption] = useState<boolean>(false);
  const [viewTXNDetailsCardObj, setViewTXNDetailsCardObj] = useState<any>({
    created: true,
    payment_submitted: false,
    payment_rejected: false,
    payment_verified: false,
    accepted_Requests: false,
    rejected_Requests: false,
  });
  const pageNoRef = useRef(pageNo);


  let txnTypeCatagory: any = [];
  txnTypeCatagory = useSelector((state: any) => state.txnTypeCategories);

  const listCheckArr = [
    "PAYMENT-VERIFIED",
    "SUBMITTED",
  ]

  const listRejectedArr = [
    "PAYMENT-REJECTED",
    "REJECTED"
  ]

  useEffect(() => {
    const getAllData = async (onStart: boolean) => {
      setLoading(true)
      const setFolio = folioNo && folioNo?.includes("DL-") ? folioNo : folioNo ? `DL-${folioNo}` : ""
      try {
        let res = await getInvestorRequestPagination(
          email,
          amc_code,
          requestType,
          setFolio?.trim(),
          requestStatus,
          pageNo?.toString()
        )
        if (res.status === 200 && res.data.status === 200) {
          setAllInvestorRequestData(
            onStart === false
              ? [...res?.data?.data?.docs]
              : [...allInvestorRequestData, ...res?.data?.data?.docs])
          setHasNextPage(res?.data?.page_info?.hasNextPage)
          setOnStartFlag(true)
        }
      }
      catch (error) {
        toast.error("No Data Found!")
        setAllInvestorRequestData([])
      }
      finally {
        setLoading(false)
      }
    }
    getAllData(onStartFlag)
    setInterval(() => {
      getAllData1(true)
    }, 600000);
  }, [refreshData])

  const getAllData1 = async (onStart: boolean) => {
    try {
      const setFolio = folioNo && folioNo?.includes("DL-") ? folioNo : folioNo ? `DL-${folioNo}` : ""
      let res = await getInvestorRequestPagination(
        email,
        amc_code,
        requestType,
        setFolio,
        requestStatus,
        pageNoRef.current?.toString()
      )
      if (res.status === 200 && res.data.status === 200) {
        setAllInvestorRequestData(
          onStart === false
            ? [...res?.data?.data?.docs]
            : [...allInvestorRequestData, ...res?.data?.data?.docs])
        setHasNextPage(res?.data?.page_info?.hasNextPage)
        setOnStartFlag(true)
      }
    }
    catch (error) {
      toast.error("No Data Found!")
      setAllInvestorRequestData([])
    }
    finally {
      setLoading(false)
    }
  }

  const handleShowMore = (value = "") => {
    if (value == "prev") {
      setPageNo(prev => prev - 1);
      pageNoRef.current = pageNo - 1;
    }
    else {
      setPageNo(prev => prev + 1);
      pageNoRef.current = pageNo + 1;
    }
    getAllData1(onStartFlag)
  };

  const changeStatus = async (item) => {
    setLoading(true)
    let status: string;
    if (item?.status == true) {
      status = "false"
    }
    else {
      status = "true"
    }
    try {
      let res = await UpdateStatusInvestorRequest(
        email,
        item?.request_id,
        amc_code,
        item?.fund_code,
        status
      )
      if (res.status === 200 && res.data.status === 200) {
        toast.success(res.data.message)
        setOnStartFlag(false)
        setPageNo(0)
        setRefreshData(!refreshData)
      }
    }
    catch (error) {
      toast.error("Error Updating Status")
      setLoading(false)
    }
  }

  useEffect(() => {
    if (fetchView && selectedItem) {
      const {
        last_upadted_at,
        request_status,
        accepted_by,
        rejected_by,
        request_type,
      } = selectedItem;

      const payment_submitted = last_upadted_at && request_status !== "PAYMENT-PENDING";
      const payment_rejected = request_status === "PAYMENT-REJECTED";
      const payment_verified = request_status === "PAYMENT-VERIFIED" || accepted_by || rejected_by;
      const rejected_Requests = rejected_by ? true : false;
      const accepted_Requests = accepted_by ? true : false;

      setViewTXNDetailsCardObj(prevState => ({
        ...prevState,
        payment_submitted,
        payment_rejected,
        payment_verified: request_type === "conversionofunits" || request_type === "redemptionofunits" ? false : payment_verified,
        accepted_Requests,
        rejected_Requests,
      }));

      setViewModalFlag(true);
    }

  }, [fetchView])

  const renderTable = () => {
    // return allInvestorRequestData?.sort((a, b) => moment(b?.creation_time)?.valueOf() - moment(a?.creation_time)?.valueOf())?.map((item: any, index: any) => {
    return allInvestorRequestData?.map((item: any, index: any) => {
      return (
        <tr key={index}>
          <td >
            {item?.fund_code}
          </td>
          <td >
            {item?.folio_no}
          </td>
          <td >
            {moment(item?.creation_time)?.format("DD-MM-YYYY h:mm : A")}
          </td>
          <td >
            {numberWithCommas(parseFloat(item?.units_requested || 0)?.toFixed(4))}
          </td>
          <td >
            {item?.request_type}
          </td>
          <td >
            {item?.request_status}
          </td>
          <td className=" ">
            <div className="multi-icons pointer align-items-center">
              <button
                type="button"
                className="btn-icon btn-link like btn btn-primary btn-sm"
                onClick={() => {
                  setFetchView(true)
                  setSelectedItem(item)
                }}
              >
                <i className="fas fa-eye"></i>
              </button>
              {listRejectedArr?.every((ele) => ele !== item?.request_status) ?
                item?.status != true ? (
                  <button
                    type="button"
                    className="btn-icon btn-link like btn btn-danger btn-sm"
                    onClick={() => {
                      changeStatus(item)
                    }}
                  >
                    <i className="tim-icons icon-simple-remove"></i>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn-icon btn-link like btn btn-success btn-sm"
                    onClick={() => {
                      changeStatus(item)
                    }}
                  >
                    <i className="fas fa-check"></i>
                  </button>
                ) : null}
              {
                (
                  (listCheckArr?.some((ele) => ele == item?.request_status)) ||
                  (
                    item?.request_status == "ACCEPTED" &&
                    item?.request_type == "redemptionofunits"
                  )
                ) &&
                <button
                  type="button"
                  className="btn-icon btn-link like btn btn-primary btn-sm"
                  onClick={() => {
                    if (item?.status == true) {
                      if (txnTypeCatagory?.length > 0) {
                        txnTypeCatagory[0].unitManagementTxn
                          ?.filter(ele1 => ele1.dis_name !== "Conversion In" && ele1.dis_name !== "Conversion Out")
                          .map(ele2 => {
                            if (ele2?.dis_name == "Sale of Units" && item?.request_type == "saleofunit") {
                              if (ele2?.api_name !== "unitconversion") {
                                sessionStorage.setItem("payment_type_IR", ele2.payment_type);
                              }
                              else {
                                sessionStorage.setItem(
                                  "payment_type_IR",
                                  "Payment"
                                );
                              }
                            }
                            else if (ele2?.dis_name == "Redemption of Units" && item?.request_type == "redemptionofunits") {
                              if (ele2?.api_name !== "unitconversion") {
                                sessionStorage.setItem("payment_type_IR", ele2.payment_type);
                              }
                              else {
                                sessionStorage.setItem(
                                  "payment_type_IR",
                                  "Payment"
                                );
                              }
                            }
                            else if (ele2?.dis_name == "Conversion of Units" && item?.request_type == "conversionofunits") {
                              if (ele2?.api_name !== "unitconversion") {
                                sessionStorage.setItem("payment_type_IR", ele2.payment_type);
                              }
                              else {
                                sessionStorage.setItem(
                                  "payment_type_IR",
                                  "Payment"
                                );
                              }
                            }
                          });
                      }
                      if (
                        (item?.request_type == "redemptionofunits" &&
                          item?.request_status !== "ACCEPTED") || item?.request_type == "conversionofunits"
                      ) {
                        setTxnModalFlag(true)
                        setSelectedItem(item)
                        const type = item?.request_type === "conversionofunits" ? "unitconversion" : item?.request_type
                        setMatch({
                          params: {
                            type: type
                          }
                        })
                      }
                      else {
                        setModalFlag(true)
                        setSelectedItem(item)
                      }
                      if (item?.request_status == "ACCEPTED" &&
                        item?.request_type == "redemptionofunits") {
                        setRedemptionAcceptKey(true)
                      }
                      else {
                        setRedemptionAcceptKey(false)
                      }
                    }
                    else {
                      toast.error("Status is inActive")
                    }
                  }}

                >
                  <BsListCheck
                    style={{
                      cursor: "pointer",
                      width: "20px",
                      height: "20px"
                    }}
                  />
                </button>}

            </div>
          </td>
        </tr>
      );
    });
  }

  const AcceptRequestPayment = async () => {
    setOnStartFlag(false)
    setPageNo(0)
    try {
      let res = await AcceptInvestorRequestPayment(
        email,
        selectedItem?.request_id || "",
        amc_code,
        selectedItem?.fund_code || "",
        comment
      )
      if (res.status === 200 && res.data.status === 200) {
        setModalFlag(false)
        setRejectedAcceptModalFlag(false)
        setComment("")
        setSelectedItem("")
        sessionStorage.removeItem("payment_type_IR")
        toast.success(res.data.message)
        // setTimeout(() => {
        setRefreshData(!refreshData)
        // }, 1000);
      }
    }
    catch (error) {
      sessionStorage.removeItem("payment_type_IR")
      toast.error("Error Accepting Payment Request")
    }
  }

  const RejectRequestPayment = async () => {
    setOnStartFlag(false)
    setPageNo(0)
    try {
      let res = await RejectInvestorRequestPayment(
        email,
        selectedItem?.request_id || "",
        amc_code,
        selectedItem?.fund_code || "",
        comment
      )
      if (res.status === 200 && res.data.status === 200) {
        setModalFlag(false)
        setComment("")
        setRejectedAcceptModalFlag(false)
        sessionStorage.removeItem("payment_type_IR")
        toast.success(res.data.message)
        // setTimeout(() => {
        setRefreshData(!refreshData)
        // }, 1000);
      }
    }
    catch (error) {
      sessionStorage.removeItem("payment_type_IR")
      toast.error("Error Rejecting Payment Request")
    }
  }

  const AcceptInvestorRequest = async () => {
    setOnStartFlag(false)
    setPageNo(0)
    const conversionOutTxn = txnIDKey
    try {
      let res = await AcceptInvestorRequestAfterTxn(
        email,
        selectedItem?.request_id || "",
        amc_code,
        selectedItem?.fund_code || "",
        comment,
        txnIDKey,
        conversionOutTxn,
        relatedTxnIDKey,
      )
      if (res.status === 200 && res.data.status === 200) {
        setModalFlag(false)
        setRejectedAcceptModalFlag(false)
        setComment("")
        setRefreshData(!refreshData)
        setSelectedItem("")
        settxnIDKey("")
        setRelatedTxnIDKey("")
        sessionStorage.removeItem("payment_type_IR")
        sessionStorage.removeItem("Txn1");
        sessionStorage.removeItem("Txn2");
        toast.success(res.data.message)
      }
    }
    catch (error) {
      settxnIDKey("")
      setRelatedTxnIDKey("")
      sessionStorage.removeItem("payment_type_IR")
      sessionStorage.removeItem("Txn1");
      sessionStorage.removeItem("Txn2");
      toast.error("Error Accepting Investor Request")

    }
  }

  const RejectInvestorsRequest = async () => {
    setOnStartFlag(false)
    setPageNo(0)
    try {
      let res = await RejectInvestorRequest(
        email,
        selectedItem?.request_id || "",
        amc_code,
        selectedItem?.fund_code || "",
        comment,
      )
      if (res.status === 200 && res.data.status === 200) {
        setModalFlag(false)
        setComment("")
        setRejectedAcceptModalFlag(false)
        setRefreshData(!refreshData)
        sessionStorage.removeItem("payment_type_IR")
        toast.success(res.data.message)
      }
    }
    catch (error) {
      sessionStorage.removeItem("payment_type_IR")
      toast.error("Error Rejecting Investor Request")
    }
  }

  useEffect(() => {
    if (txnIDKey && relatedTxnIDKey) {
      AcceptInvestorRequest()
    }
    else if (txnIDKey && relatedTxnIDKey === "") {
      AcceptInvestorRequest()
    }
  }, [txnIDKey])

  const PaymentProofUpdate = async (MOP = "", BAC = "") => {
    setOnStartFlag(false)
    setPageNo(0)
    try {
      let res = await UpdatePaymentProof(
        "true",
        profilePicture,
        email,
        amc_code,
        selectedItem?.fund_code,
        selectedItem?.folio_no,
        selectedItem?.request_id,
        BAC,
        MOP
      )
      if (res.status === 200 && res.data.status === 200) {
        setComment("")
        setProfilePicture("")
        setImage("")
        setSelectedItem("")
        setModalFlag(false)
        setLoaderImageUploadRedemption(false)
        setRefreshData(!refreshData)
        toast.success(res.data.message)
      }
    } catch (error) {
      toast.error("Error Updating Payment Proof")
      setLoaderImageUploadRedemption(false)
    }
  }

  const getTxnById = async (searchkey = "") => {
    setLoaderImageUploadRedemption(true)
    try {
      let res = await searchTransactions(
        email,
        amc_code,
        "",
        "",
        searchkey,
        "",
        "redemptionofunits"
      )
      if (res.status === 200 && res?.data?.status === 200) {
        PaymentProofUpdate(res?.data?.data[0]?.mode_of_payment, res?.data?.data[0]?.account_number)
      }
    } catch (error) {
      toast.error(`No Corresponding TXN found for ${searchkey}`)
      setLoaderImageUploadRedemption(false)
    }
  }

  return (
    <div className="content">

      <ToastContainer />

      {/* ---------------- Modal ------------ */}
      <Modal
        className=""
        dialogClassName="modal90w"
        show={modalFlag ? true : false}
        size="lg"
        backdrop={true}
        onHide={() => {
          setModalFlag(false);
          setImage("")
          setProfilePicture("")
          sessionStorage.removeItem("payment_type_IR")
        }}
        centered={true}
      >
        <div className="modal-header ">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setModalFlag(false);
              setImage("")
              setProfilePicture("")
              sessionStorage.removeItem("payment_type_IR")
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">
            {selectedItem?.request_status == "ACCEPTED" ?
              "Payment Verification" :
              redemptionAcceptKey ?
                "Upload Payment Proof" :
                "Payment Verification"
            }
          </h6>
        </div>
        <div className="modal-body">
          <Row>
            {
              redemptionAcceptKey ?
                <>
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(event) => {
                      const reader = new FileReader();
                      reader.onload = () => {
                        if (typeof reader.result === 'string') {
                          setImage(reader.result);
                        } else {
                          console.error("FileReader result is not a string.");
                        }
                      };
                      if (event.target.files) {
                        let file = event.target.files[0];
                        if (file) {
                          let type = file.name
                            .substring(file.name.lastIndexOf(".") + 1)
                            ?.toLowerCase();
                          let imgSize = file.size;
                          if (imgSize > 1048576) {
                            toast.error(
                              "Image size should be less than 1MB"
                            );
                          } else if (
                            type === "png" ||
                            type === "jpg" ||
                            type === "jpeg"
                          ) {
                            setProfilePicture(event.target.files[0]);
                            reader.readAsDataURL(event.target.files[0]);
                          } else {
                            toast.error("Invalid Format");
                          }
                        }
                      }
                    }}
                    className="form-control"
                  />
                  {image &&
                    <div className="d-flex justify-content-center mt-3 w-100">
                      <img
                        style={{
                          height: 300,
                          width: 300,
                          objectFit: "contain",
                          objectPosition: "center"
                        }}
                        src={image} />
                    </div>}
                </>
                :
                <div className="d-flex justify-content-center mt-3 w-100">
                  <img
                    style={{
                      height: 300,
                      // width: 300,
                      // objectFit: "contain",
                      // objectPosition: "center"
                    }}
                    src={selectedItem?.payment_proof}
                  />
                </div>
            }

          </Row>
        </div>
        <div className="modal-footer p-3 d-flex justify-content-between">
          {
            (redemptionAcceptKey
              || selectedItem?.request_status !== "ACCEPTED") &&
            <>
              <Button
                onClick={() => {
                  if (selectedItem?.request_status == "SUBMITTED") {
                    setKeyForRejectAccept("RIP") // RIP (Reject Invvestor Payment)
                    setRejectedAcceptModalFlag(true)
                  }
                  else if (selectedItem?.request_status == "PAYMENT-VERIFIED") {
                    setKeyForRejectAccept("RIR") // RIP (Reject Invvestor Request)
                    setRejectedAcceptModalFlag(true)
                  }
                  else if (redemptionAcceptKey) {
                    setModalFlag(false)
                  }
                  setImage("")
                  setProfilePicture("")
                }}
              >
                {redemptionAcceptKey ? "Cancel" : "Reject"}
              </Button>
              <Button
                disabled={loading || loaderImageUploadRedemption}
                onClick={() => {
                  if (selectedItem?.request_status == "SUBMITTED") {
                    setKeyForRejectAccept("AIP") // AIP (Accept Invvestor Payment)
                    setRejectedAcceptModalFlag(true)
                  }
                  else if (selectedItem?.request_status == "PAYMENT-VERIFIED") {
                    setMatch({
                      params: {
                        type: selectedItem?.request_type
                      }
                    })
                    setTxnModalFlag(true)
                  }
                  else if (redemptionAcceptKey) {
                    if (profilePicture == "" || profilePicture == undefined) {
                      toast.error("Kindly upload Payment Proof")
                      return
                    }
                    const txnIDPattern = `TXN_${selectedItem?.related_txn_id}`
                    getTxnById(txnIDPattern)
                  }
                }}
                color='primary'>
                {redemptionAcceptKey ? "Submit" : "Accept"}
              </Button>
            </>
          }
        </div>
      </Modal>

      {/* ---------------- Modal for Rejected Reasons ------------ */}
      <Modal
        className=""
        dialogClassName="modal90w"
        show={rejectedAcceptedModalFlag ? true : false}
        size="sm"
        backdrop={true}
        onHide={() => {
          setRejectedAcceptModalFlag(false);
          sessionStorage.removeItem("payment_type_IR")
          setComment("")
        }}
        centered={true}
      >
        <div className="modal-header ">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setRejectedAcceptModalFlag(false);
              sessionStorage.removeItem("payment_type_IR")
              setComment("")
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">
            {keyForRejectAccept == "RIP" || keyForRejectAccept == "RIR" ?
              "Reason Rejecting" :
              "Reason for Accepting"
            }
          </h6>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Reason</label>
            <textarea
              rows={3}
              className="form-control"
              placeholder='Enter Reason'
              value={comment}
              onChange={(e) => {
                setComment(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="modal-footer p-3 d-flex justify-content-between">
          {(selectedItem?.request_status !== "ACCEPTED") &&
            <>
              <Button
                onClick={() => {
                  setRejectedAcceptModalFlag(false)
                  setComment("")
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={loading}
                onClick={() => {
                  if (keyForRejectAccept == "RIP") {
                    RejectRequestPayment()
                  }
                  else if (keyForRejectAccept == "RIR") {
                    RejectInvestorsRequest()
                  }
                  else {
                    AcceptRequestPayment()
                  }
                }}
                color='primary'>
                Submit
              </Button>
            </>
          }
        </div>
      </Modal>

      {/* ---------------- Modal for respective TXN ------------ */}
      <Modal
        className="mx-2 w-full"
        dialogClassName="modal100w"
        show={txnModalFlag ? true : false}
        size="xl"
        backdrop={true}
        onHide={() => {
          setTxnModalFlag(false);
          sessionStorage.removeItem("payment_type_IR")
          sessionStorage.removeItem("Txn1");
          sessionStorage.removeItem("Txn2");
        }}
        centered={true}

      >
        <div className="modal-header ">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setTxnModalFlag(false);
              sessionStorage.removeItem("Txn1");
              sessionStorage.removeItem("Txn2");
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">
            Create Transaction
          </h6>
        </div>
        <div className="modal-body">
          <InvestorRequestTransaction
            match={match}
            selectedItems={selectedItem}
            settxnIDKey={settxnIDKey}
            setTxnModalFlag={setTxnModalFlag}
            setRelatedTxnIDKey={setRelatedTxnIDKey}
          />
        </div>
      </Modal>

      {/* ---------------- View Modal ------------ */}
      <Modal
        className=""
        dialogClassName="modal90w"
        show={viewModalFlag ? true : false}
        size="xl"
        backdrop={true}
        onHide={() => {
          setViewModalFlag(false);
          setViewTXNDetailsCardObj({
            created: true,
            payment_rejected: false,
            payment_verified: false,
            payment_submitted: false,
            accepted_Requests: false,
            rejected_Requests: false,
          })
          setFetchView(false)
          setSelectedItem("")
        }}
        centered={true}
      >
        <div className="modal-header ">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setViewModalFlag(false);
              setViewTXNDetailsCardObj({
                created: true,
                payment_rejected: false,
                payment_verified: false,
                payment_submitted: false,
                accepted_Requests: false,
                rejected_Requests: false,
              })
              setFetchView(false)
              setSelectedItem("")
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">
            View Investor Request
          </h6>
        </div>
        <div className="modal-body">
          <ViewInvesterRequest
            selectedItem={selectedItem}
            viewTXNDetailsCardObj={viewTXNDetailsCardObj}
          />
        </div>
        <div className="modal-footer p-3 d-flex justify-content-between">
          <Button
            onClick={() => {
              setViewModalFlag(false)
              setViewTXNDetailsCardObj({
                created: true,
                payment_rejected: false,
                payment_verified: false,
                payment_submitted: false,
                accepted_Requests: false,
                rejected_Requests: false,
              })
              setFetchView(false)
              setSelectedItem("")
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal>

      <Row>
        <Col md="12">
          <Container fluid>
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  Investor Requests Listing
                </h4>

              </div>
              {!loading ? (
                <div className="card-body">
                  <Row className="align-items-baseline">
                    <Col md="4">
                      <ReactTooltip
                        textColor="white"
                        backgroundColor="black"
                        effect="float"
                      />
                      <div className="form-group">
                        <input
                          type="search"
                          id="myInput"
                          placeholder="Enter Folio Number"
                          data-tip="Folio No"
                          className="form-control py-1"
                          value={folioNo}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                              setRefreshData(!refreshData)
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.value) {
                              setFolioNo(e.target.value);
                              setOnStartFlag(false)
                              setPageNo(0)
                            }
                            else {
                              setRefreshData(!refreshData)
                              setFolioNo("");
                              setOnStartFlag(false)
                              setPageNo(0)
                            }
                          }}
                        />
                      </div>
                    </Col>
                    <Col md="4">
                      <div className="">
                        <button
                          className="btn btn-primary mr-4 py-2 mt-0"
                          disabled={Boolean(loading) || folioNo == ""}
                          onClick={() => {
                            setRefreshData(!refreshData)
                            setPageNo(0)
                          }}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border login-txt spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="login-txt"> Searching...</span>
                            </>
                          ) : (
                            <span>
                              {" "}
                              <i className="fa fa-search mr-1"></i>Search
                            </span>
                          )}
                        </button>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                      {requestStatusArr?.map((item, index) => {
                        return (
                          <button
                            key={index}
                            id={item?.value == requestStatus ? "" : "outlined_button_info"}
                            className={`rounded-pill fs btn btn-info btn-sm ${item?.value == requestStatus ? "" : "border"}`}
                            onClick={() => {
                              if (item?.value !== requestStatus) {
                                setRequestStatus(item?.value)
                                setRefreshData(!refreshData)
                                setPageNo(0)
                                setOnStartFlag(false)
                              }
                            }}
                          >
                            {item?.label}
                          </button>
                        )
                      })}
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                      <div className="d-flex justify-content-end">
                        {
                          requestTypeArr?.map((item, index) => {
                            return (
                              <button
                                key={index}
                                id={item?.value == requestType ? "" : "outlined_button_info"}
                                className={`rounded-pill fs btn btn-sm btn-info ${item?.value == requestType ? "" : "border"}`}
                                onClick={() => {
                                  if (item?.value !== requestType) {
                                    setRequestType(item?.value)
                                    setRefreshData(!refreshData)
                                    setPageNo(0)
                                    setOnStartFlag(false)
                                  }
                                }}
                              >
                                {item?.label}
                              </button>
                            )
                          })
                        }
                      </div>
                    </Col>
                  </Row>
                  <div className="table-responsive">
                    {
                      allInvestorRequestData?.length > 0 ?
                        <table id="scrollDown" className="table mt-3 ">
                          <thead>
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Fund Code
                            </th>
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Folio No
                            </th>
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Created At
                            </th>
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Units Requested
                            </th>
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Request Type
                            </th>
                            <th
                              style={{
                                paddingLeft: "5px",
                                paddingRight: "5px",
                              }}
                            >
                              Request Status
                            </th>
                            <th
                              style={{
                                paddingLeft: "11px",
                                paddingRight: "11px",
                              }}
                            >
                              Action
                            </th>

                          </thead>
                          <tbody>{renderTable()}</tbody>
                        </table>
                        :
                        <div className="text-center my-5">
                          <b>No Data Found</b>
                        </div>
                    }
                  </div>
                </div>
              ) : (
                <div className="d-flex justify-content-center">
                  <div
                    className="fa fa-spinner fa-spin fa-3x mt-5 mb-5"
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}

              <div
                className='d-flex justify-content-center my-2'
              >
                <div className="d-flex">
                  {hasNextPage && (<button
                    className="btn btn-primary mt-3 mx-2"
                    onClick={() => handleShowMore("next")}
                  >
                    Show More
                  </button>
                  )}
                </div>
              </div>

            </div>
          </Container>
        </Col>
      </Row>
    </div>
  );
};

export default InvestedRequest;
